import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useSelector } from 'react-redux';
import { getHomeBannerService } from '../services/apiServices';
import { isEmptyObj } from '../utilities';
import { isMobile } from 'react-device-detect';

const settings = {
  infinite: true,
  speed: 400,
  centerMode: isMobile ? false : true,
  slidesToScroll: 1,
  slidesToShow: 1,
  centerPadding: '200px',
  lazyLoad: true,
  initialSlide: 0,
  arrows: true,
  dots: false,
  autoplay: true,
  focusOnSelect: true,
};

function Banners({bannersDetails}) {

  const navigate = (url) => {
    if (url) {
      window.open(url, '_blank');
    } else {
      return false;
    }
  };

  return bannersDetails.length > 0 ? (
    <section id='banners'>
      <Slider {...settings} className={!isMobile ? 'slickArrows' : ''}>
        {bannersDetails.map((items) => {
          return (
            <div key={items.id} onClick={() => navigate(items.callToActionLink)}>
              <figure>
                <img style={items.callToActionLink ? {cursor: "pointer"} : {}} src={isMobile ? (items.contentMediaAppUrl ? items.contentMediaAppUrl : items.contentMediaUrl) : items.contentMediaUrl} alt={items.title} />
              </figure>
            </div>
          );
        })}
      </Slider>
    </section>
  ) : (
    ''
  );
}

export default Banners;
